<template>
  <div class="right-top">
    <div class="avatar">
      <img :src="avatar" />
    </div>
    <div class="user">
      管理员：<span>{{ info.name }}</span>
    </div>
    <div @click="logout" class="btn">退出登录</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ACCESS_TOKEN, USER_INFO } from '@store/mutation-types.js'
import storage from 'store'

export default {
  data() {
    return {
      info: storage.get(USER_INFO)
    }
  },
  computed: {
    ...mapState({
      avatar: (state) => state.user.avatar,
    }),
  },
  methods: {
    logout() {
      storage.remove(ACCESS_TOKEN)
      this.$router.push('/login')
    },
  },
}
</script>

<style lang="less" scoped>
.right-top {
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .avatar {
    width: 200px;
    height: 200px;
    padding: 33px;
    background: url(../../assets/dongti/avatar-border.png) no-repeat center center/cover;
    margin-bottom: 10px;
    img {
      width: 136px;
      height: 136px;
      border-radius: 50%;
      overflow: hidden;
      background: #eee;
    }
  }
  .user {
    font-size: 16px;
    font-weight: bold;
  }
  .btn {
    cursor: pointer;
    margin-top: 10px;
    width: 170px;
    height: 40px;
    background: url(../../assets/dongti/logout.png) center center/cover;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}
</style>
